import { Navigate, Outlet, useLocation, useParams } from "react-router-dom";
import { LangContext, LANGS } from "../../i18n/lang";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { SmoothScroll } from "./SmoothScroll";
import { CookieBanner } from "./CookieBanner";

export const SiteLayout = () => {
  const { lang } = useParams();
  const { pathname } = useLocation();
  if (!LANGS.includes(lang)) return <Navigate to={`/en${pathname}`} replace />;
  const isHome = pathname === `/${lang}` || pathname === `/${lang}/`;
  return (
    <LangContext.Provider value={lang}>
      <SmoothScroll />
      <a href="#content" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[70] bg-[#1A1A1A] text-[#FFFFFF] px-4 py-2">Skip to content</a>
      <Header overlay={isHome} />
      <div id="content"><Outlet /></div>
      <Footer />
      <CookieBanner />
    </LangContext.Provider>
  );
};

export const RootRedirect = () => {
  const pref = (navigator.language || "en").toLowerCase().startsWith("it") ? "it" : "en";
  return <Navigate to={`/${pref}`} replace />;
};
